import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// Styles
import styled, { css } from 'styled-components';
import colors from 'UIKit/Colors';
import mq from 'UIKit/Mq';

// Components
import SidebarContent from './SidebarContent';
import logoNavCollapsed from './icons/logoNavCollapsed.svg';
import logo from './icons/logo.svg';

// StyledComponents
const SidebarStyled = styled.div`
  overflow: hidden;
  position: relative;
  z-index: 1;
  min-width: 240px;
  max-width: 270px;
  box-shadow: 10px 0 20px rgba(0, 0, 0, 0.06);
  background-color: #fff;
  transition: all 0.3s;
  ${mq.tabletHorizontal`
    position: fixed;
    z-index: 2;
    top: 0;
    bottom: 0;
    min-width: 270px;
    max-width: 300px;
    transform:translateX(0)
    `};
  ${mq.tablet`
    width: 75%;
    `};
  ${({ navCollapsed }) =>
    navCollapsed &&
    css`
      overflow: initial;
      min-width: 65px;
      max-width: 65px;
      ${mq.tabletHorizontal`
        z-index: 0;
        transform:translateX(-100%)
        `};
    `};
`;
const SidebarWrap = styled.div`
  height: calc(100% - 64px);
  background-color: ${colors.white['0']};
`;

const Logo = styled(Link)`
  display: flex;
  align-items: center;
  width: 100%;
  height: 64px;
  padding: 5px 24px;
  background-image: linear-gradient(
    225deg,
    ${colors.brand['600']} 0%,
    ${colors.brand['600']} 100%
  );
  box-shadow: 0 10px 20px ${colors.shadow['100']};
  color: ${colors.white['0']};
  ${mq.tablet`height:56px`};
  svg {
    fill: #fefefe;
    stroke: none;
    stroke-width: 1px;
    &:first-child {
      width: 40px;
      height: 50px;
    }
    &:last-child {
      width: 160px;
      height: 55px;
    }
  }
  &._nav-collapsed {
    padding: 5px 16px;
    svg {
      &:last-child {
        ${mq.tabletHorizontal`
          display: block;
        `};
      }
    }
    ${mq.tabletHorizontal`
      padding: 5px 24px;
    `};
  }
`;

const Sidebar = ({ navCollapsed }) => {
  return (
    <SidebarStyled navCollapsed={navCollapsed}>
      <Logo to="/" className={navCollapsed ? '_nav-collapsed' : null}>
        {navCollapsed ? (
          <img src={logoNavCollapsed} alt="logo" />
        ) : (
          <img src={logo} alt="logo" />
        )}
      </Logo>
      <SidebarWrap>
        {/* ToDo: add scroll */}
        <SidebarContent navCollapsed={navCollapsed} />
      </SidebarWrap>
    </SidebarStyled>
  );
};

Sidebar.propTypes = {
  navCollapsed: PropTypes.any.isRequired,
};

export default Sidebar;
